<template>
  <div>
    <Heading title="Collections" subTitle="Customize look &amp; feel of AMP for collections." targetPlan="basic" tryForFree />

    <div class="accordion mb-45" id="collection-collapse-group">
      <CollapseItem open label="Title" parent="#collection-collapse-group" highlight=".h4.collection-title">
        <Customizer
          category="collectionTitle"
          basic
          font
          space
          border :borderConfig="{ hideBorderRadius: true }">
          <div class="row row-space-4">
            <div class="col-md-6">
              <label>Text Color</label>
              <ColorCustomizer
                category="collectionTitle" type="color" />
            </div>
          </div>
        </Customizer>
      </CollapseItem>
      <CollapseItem label="Description" parent="#collection-collapse-group" highlight=".collection-description" toggle="hide_collection_description">
        <Customizer
          category="collectionDescription"
          space :spaceConfig="{ hidePadding: true }">
        </Customizer>
      </CollapseItem>
    </div>

    <Heading h2 title="Product Grid" subTitle="Following configuration applies to all products in the product grid." />

    <div class="accordion">
      <CollapseItem label="Basic" parent="#collection-collapse-group" highlight=".product-grid">
        <FontCustomizer category="productGridText" :config="{ hideFontFamily: true, hideFontSize: true, hideTextTransform: true }" />
      </CollapseItem>
      <CollapseItem label="Product Title" parent="#collection-collapse-group" highlight=".product-grid-product-title">
        <Customizer
          category="productGridProductTitle"
          font :fontConfig="{ hideTextAlign: true }"
          space :spaceConfig="{ hidePadding: true }"
          basic>
          <div class="row row-space-4">
            <div class="col-md-6">
              <label>Text Color</label>
              <ColorCustomizer
                category="productGridProductTitle" type="color" />
            </div>
          </div>
        </Customizer>
      </CollapseItem>
      <CollapseItem label="Product Type" parent="#collection-collapse-group" highlight=".product-grid-product-type" toggle="product_grid_product_type">
        <Customizer
          category="productGridProductType"
          font :fontConfig="{ hideTextAlign: true }"
          space :spaceConfig="{ hidePadding: true }"
          basic>
          <div class="row row-space-4">
            <div class="col-md-6">
              <label>Text Color</label>
              <ColorCustomizer
                category="productGridProductType" type="color" />
            </div>
          </div>
        </Customizer>
      </CollapseItem>
      <CollapseItem label="Inline Review" parent="#collection-collapse-group" highlight=".review-mini">
        <Customizer
          category="productGridReview"
          font :fontConfig="{ hideFontFamily: true, hideTextTransform: true, hideTextAlign: true }" />

        <p class="mb-0 font-weight-normal">Go to <router-link :to="{ name: 'amp_products' }">Product &gt; Inline Review</router-link> to customize style of inline review.</p>
      </CollapseItem>
      <CollapseItem label="Price" parent="#collection-collapse-group" highlight=".product-grid-product-price">
        <Customizer
          category="productGridProductPrice"
          basic
          font :fontConfig="{ hideTextTransform: true, hideTextAlign: true }"
          space :spaceConfig="{ hidePadding: true }"
          class="mb-4">
          <div class="row row-space-4 mb-4">
            <div class="col-md-6">
              <label>Text Color</label>
              <ColorCustomizer
                category="productGridProductPrice" type="color" />
            </div>
          </div>
        </Customizer>

        <p class="mb-0 font-weight-normal">To customize style of the savings badge, please go to <router-link :to="{ name: 'amp_products' }">Product &gt; Cart &amp; Pricing &gt; Savings</router-link>.</p>
      </CollapseItem>
      <CollapseItem label="Sold Out Sticker" parent="#collection-collapse-group" highlight=".product-unavailable" toggle="product_grid_sold_out_sticker">
        <Customizer
          category="productGridSoldOut"
          basic
          font :fontConfig="{ hideTextAlign: true, hideTextTransform: true }"
          space :spaceConfig="{ hideMargin: true }"
          border>
          <div class="row row-space-4">
            <div class="col-md-6">
              <label>Text</label>
              <input type="text" class="form-control" v-model="language__product_grid_products_sold_out_text">
            </div>
          </div>
          <div class="row row-space-4">
            <div class="col-md-6">
              <label>Background Color</label>
              <ColorCustomizer
                category="productGridSoldOut" type="backgroundColor" setTextColor />
            </div>
            <div class="col-md-6">
              <label>Text Color</label>
              <ColorCustomizer
                category="productGridSoldOut" type="color" />
            </div>
          </div>
        </Customizer>
      </CollapseItem>
    </div>

    <SaveButton :hasChanged="hasChanged" @click="saveMaster" bar discard />
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'

import CollapseItem from '@/components/CollapseItem'
import Customizer from '@/components/customizers/Customizer'

import ColorCustomizer from '@/components/customizers/ColorCustomizer'
import FontCustomizer from '@/components/customizers/FontCustomizer'
import LayoutOptionsCustomizer from '@/components/customizers/LayoutOptionsCustomizer'
import SaveButton from '@/components/SaveButton'
import UpgradeBadge from '@/components/UpgradeBadge'

import watchForChange from '@/mixins/watchForChange'
import mapMultiComputed from '@/mixins/mapMultiComputed'

export default {
  mixins: [
    watchForChange(),
    mapMultiComputed('settings', [
      'language.product_grid_products_sold_out_text',
      'language.filter_button_text'
    ])
  ],
  components: {
    Customizer,
    CollapseItem,
    SaveButton,
    ColorCustomizer,
    FontCustomizer,
    UpgradeBadge,
    LayoutOptionsCustomizer
  },
  computed: mapState(['currentPreviewType']),
  methods: mapActions(['saveMaster']),
  mounted: function () {
    if (this.currentPreviewType !== 'collection') {
      this.$store.commit('SWITCH_PREVIEW_TYPE', 'collection')
    }
  }
}
</script>
